import { mentionType } from '@aline/common';
import { MentionInputPlugin, MentionPlugin } from '@platejs/mention/react';

import { ReportColumnMentionElement } from './ReportColumnMentionElement';
import { ReportColumnMentionInputElement } from './ReportColumnMentionInputElement';

export * from './ReportColumnMentionContext';
export * from './ReportColumnMentionInputElement';

export const ReportColumnMentionKit = [
  MentionPlugin.configure({
    options: {
      triggerPreviousCharPattern: /^$|^[\s"']$/,
    },
    parsers: {
      html: {
        deserializer: {
          parse: ({ element }) => ({
            columnId: element.getAttribute('data-column-id'),
            columnName: element.textContent || '',
            mentionTypeName: 'report-column',
            type: mentionType,
            value: element.textContent || '',
          }),
          rules: [{ validAttribute: 'data-slate-mention' }],
        },
      },
    },
  }).withComponent(ReportColumnMentionElement),
  MentionInputPlugin.configure({
    node: {
      isInline: true,
      isVoid: false,
    },
  }).withComponent(ReportColumnMentionInputElement),
];
